export default __webpack_public_path__ + "static/media/login_bg.db7c1acf.svg";